import { render, staticRenderFns } from "./BotaoManuseiaAta.vue?vue&type=template&id=419ca7b6&scoped=true"
import script from "./BotaoManuseiaAta.vue?vue&type=script&lang=js"
export * from "./BotaoManuseiaAta.vue?vue&type=script&lang=js"
import style0 from "./BotaoManuseiaAta.vue?vue&type=style&index=0&id=419ca7b6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419ca7b6",
  null
  
)

export default component.exports